module.exports = __webpack_public_path__ + "Assets/95a1e677-b284-4b7e-86f9-b684fba2e7da.ttf";